import * as Long from "long";
import { of } from "rxjs";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { selectNotEnoughResourcesMissingResources } from "../../../../selectors/selectNotEnoughResources";
import { actionShopOpenOffer } from "../../../shop/actionShop";
import { actionProductionBoostMissingRecipeCost, } from "../actionProductionInfo";
export var pathNotEnoughHumus = function (action, state$) {
    var state = state$.value;
    var costs = action.recipe.cost;
    var missingCost = costs.find(function (cost) {
        var availableCost = selectInventoryResourceInfo(state, cost.id);
        return availableCost.amount.equals(Long.ZERO);
    });
    if (missingCost && missingCost.onlyFromOffer) {
        return of(actionShopOpenOffer(missingCost.onlyFromOffer));
    }
    var missingResources = selectNotEnoughResourcesMissingResources(state$.value, [
        {
            amount: missingCost.amount || Long.ONE,
            typeId: missingCost.id,
        },
    ]);
    return of(actionProductionBoostMissingRecipeCost(action.building, action.recipe, missingResources));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/path/pathNotEnoughHumus.ts
// module id = 1943
// module chunks = 3